var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFullBasket = function SvgFullBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.966 5.938v8.233h9.068V5.938h2.591v1.266H15.33v8.234H3.67V7.204H2.375V5.938h2.59zm3.986 4.342v2.172H6.76V10.28h2.192zm3.288 0v2.172h-2.192V10.28h2.192zm0-3.257v2.172h-2.192V7.023h2.192zm-3.288 0v2.172H6.76V7.023h2.192z",
    fill: "#000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19v19H0z"
  }))));
};

export default SvgFullBasket;